export const EXTENDED_TIMEOUT = {
  timeout: 30000
};
